import React, { useState, useEffect, useMemo } from 'react'
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import ReactDataTableBootstrap from '../../Components/ReactDataTableBootstrap/ReactDataTableBootstrap';
import Controllers from '../../Api/Controllers';
import Encuesta1Form from './Encuesta1Form'
import { toast } from 'react-toastify';
import Helpers from '../../Components/Helpers/Helpers';

const Encuesta1List = ({ nameSingle, namePlural, separator }) => {
    const [isProcessing, setIsProccesing] = useState(true)
    const [modalShow, setModalShow] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [reload, setReload] = useState(true);
    const [rows, setRows] = useState([])
    const [loadSubmit, setLoadSubmit] = useState(false)
    const [dataUpdated, setDataUpdated] = useState({})

    useEffect(() => {
        if (reload) {
            setIsProccesing(true)
            Controllers.encuesta.encuesta_1_get().then(res => {
                setRows(res.data)
            }).catch(req => Helpers.promise.catch({ req, toast }))
            .finally(() => {
                setIsProccesing(false)
                setReload(false)
            })
        }
    }, [reload])

    const handleGet = e => {
        let $this = e.currentTarget

        let buttonHTML = $this.innerHTML;
        $this.innerHTML = '<i class="fa fa-circle-notch fa-spin"></i>'
        let { idEncuesta } = $this.dataset

        Controllers.encuesta.encuesta_1_resultados({ p_id_encuesta: idEncuesta }).then(res => {
            setModalTitle(`Resultados ${nameSingle} #${idEncuesta}`)
            setDataUpdated({ data: res.data })
            setModalShow(true);
        }).catch(req => {
            Helpers.promise.catch({ req, toast })
            setReload(true)
        })
        .finally(() => $this.innerHTML = buttonHTML)
    }

    const handleExport = e => {
        let $this = e.currentTarget

        let buttonHTML = $this.innerHTML;
        $this.innerHTML = '<i class="fa fa-circle-notch fa-spin"></i>'
        let { idEncuesta } = $this.dataset

        Controllers.encuesta.encuesta_1_resultados_excel({ p_id_encuesta: idEncuesta }).then(res => {
            const { data } = res
            const link = document.createElement('a');
            link.setAttribute('href', data.excel.file);
            link.setAttribute('download', `${data.filename}`);
            document.body.appendChild(link);
            link.click();
            link.remove()
        }).catch(req => {
            Helpers.promise.catch({ req, toast })
            setReload(true)
        })
        .finally(() => $this.innerHTML = buttonHTML)
    }

    const handleHideModalForm = () => {
        setModalShow(false)
        setLoadSubmit(false)
    }

    const dtRows = useMemo(() => <ReactDataTableBootstrap
        head={[
            [
                { name: 'id_encuesta', text: 'ID', align: 'center' },
                { name: 'name_user', text: 'Nombres' },
                { name: 'age_user', text: 'Edad', align: 'center' },
                { name: 'job_user', text: 'Puesto', align: 'center' },
                { name: 'points', text: 'Puntos', align: 'center' },
                { name: 'created_at', text: 'Fecha Creación', align: 'center' },
                { name: 'calification', text: 'Calificación', align: 'center', render: r => {
                    return <div>
                        <span className="badge" style={{
                            background: r.calification_color,
                            color: r.calification_color_text
                        }}>{r.calification}</span>
                    </div>
                } },
                { name: 'actions', text: <i className="fa fa-cog"></i>, align: 'center', render: u => {
                    return <div>
                        <Button variant="info" className="mr-1" size="xs" data-id-encuesta={u.id_encuesta} onClick={handleGet}>
                            <i className="fa fa-eye"></i>
                        </Button>
                        <Button variant="success" className="mr-1" size="xs" data-id-encuesta={u.id_encuesta} onClick={handleExport}>
                            <i className="fa fa-file-excel"></i>
                        </Button>
                    </div>
                } },
            ],
        ]}
        rows={rows}
        isProcessing={isProcessing}
    />, [rows, isProcessing])

    return <>
        <Card>
            <Card.Header className="justify-content-between">
                <span>Listado De {namePlural}</span>
            </Card.Header>
            <Card.Body>
                { dtRows }
            </Card.Body>
        </Card>
        <Modal show={modalShow} onHide={handleHideModalForm} backdrop="static" size='xl'>
            <Modal.Header closeButton>
                <Modal.Title as="div">{modalTitle}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <Encuesta1Form {...dataUpdated} />
            </Modal.Body>
        </Modal>
    </>
}

export default Encuesta1List